/* bbd-product-information.js
 * Handles tabbed interface and read-more toggle for the
 * bbd-product-information section. Designed to support multiple
 * instances on a page.
 */
(function () {
  'use strict';

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function setupReadMore(panel) {
    if (!panel) return;
    var rm = panel.querySelector('[data-readmore]');
    if (!rm) return;
    var content = rm.querySelector('.bbd-readmore__content');
    var btn = rm.querySelector('.bbd-readmore__toggle');
    if (!content || !btn) return;

    var threshold = parseInt(rm.getAttribute('data-threshold'), 10);
    if (isNaN(threshold)) threshold = 300; // fallback to 300px if not provided

    // Pull localized labels from data-attributes (with sensible fallbacks)
    var moreText = btn.getAttribute('data-readmore') || btn.dataset.readmore || 'Read more';
    var lessText = btn.getAttribute('data-readless') || btn.dataset.readless || 'Read less';

    // Measure accurately: ensure panel is visible during measurement
    var wasHidden = panel.hasAttribute('hidden');
    if (wasHidden) panel.hidden = false;
    var overflowing = content.scrollHeight > threshold + 1; // avoid off-by-one
    if (wasHidden) panel.hidden = true;

    if (overflowing) {
      rm.classList.add('has-toggle');
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (!expanded) {
        rm.classList.add('is-collapsed');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = moreText;
      }
    } else {
      rm.classList.remove('has-toggle');
      rm.classList.remove('is-collapsed');
      btn.setAttribute('aria-expanded', 'false');
      // Ensure button label is reset for next time it might be shown
      btn.textContent = moreText;
    }

    if (!btn.dataset.bound) {
      btn.addEventListener('click', function () {
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          btn.setAttribute('aria-expanded', 'false');
          rm.classList.add('is-collapsed');
          btn.textContent = moreText;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          rm.classList.remove('is-collapsed');
          btn.textContent = lessText;
        }
      });
      btn.dataset.bound = '1';
    }
  }

  function activateTab(root, tab, tabs, panels) {
    tabs.forEach(function (t) {
      var selected = t === tab;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      t.setAttribute('tabindex', selected ? '0' : '-1');
    });
    panels.forEach(function (p) {
      var show = p.getAttribute('aria-labelledby') === tab.id;
      p.hidden = !show;
      if (show) {
        setupReadMore(p);
      }
    });
    tab.focus();
  }

  function initTabs(root) {
    var tabs = toArray(root.querySelectorAll('[role="tab"]'));
    var panels = toArray(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(root, tab, tabs, panels);
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateTab(root, tab, tabs, panels);
        }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var idx = tabs.indexOf(tab);
          var next = e.key === 'ArrowRight' ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;
          activateTab(root, tabs[next], tabs, panels);
        }
      });
    });

    // Initialize read-more on initially visible panel
    var initiallyVisible = panels.find(function (p) {
      return !p.hasAttribute('hidden');
    });
    if (initiallyVisible) setupReadMore(initiallyVisible);

    // Re-evaluate on window resize for the currently visible panel
    window.addEventListener('resize', function () {
      var visible = panels.find(function (p) {
        return !p.hasAttribute('hidden');
      });
      if (visible) setupReadMore(visible);
    });
  }

  function initAll() {
    var roots = toArray(document.querySelectorAll('.bbd-product-information__tabs'));
    roots.forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
